/**
 * Collapsible component.
 *
 * Collapsible content component for showing/hiding content. Built on Radix UI
 * primitives with smooth animations and accessible keyboard navigation.
 *
 * @module collapsible
 */

import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";

const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;

const CollapsibleContent = CollapsiblePrimitive.CollapsibleContent;

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
